// extracted by mini-css-extract-plugin
export default {"labelLike":"label-like__labelLike___1TrjN","inline":"label-like__inline___3K0aA","light":"label-like__light___1_gI_"};